import { render, staticRenderFns } from "./AboutUsAdd.vue?vue&type=template&id=e328dad6&scoped=true"
import script from "./AboutUsAdd.vue?vue&type=script&lang=js"
export * from "./AboutUsAdd.vue?vue&type=script&lang=js"
import style0 from "./AboutUsAdd.vue?vue&type=style&index=0&id=e328dad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e328dad6",
  null
  
)

export default component.exports